// import requester from '@/assets/dataSources/zforms/requester.js';


export class EntityMeta {
  constructor(rootEntity) {
    this.rootEntity = rootEntity;
    this.entityViewField = null;
    this.entityUidField = null;
    this.zfType = null;
    this.entityName = null;
    this.dsUid = null;
    this.fields = {};
    this.actions = [];
    this.metaAttrName = '__meta__';
  }

  async _updateParamsFromRaw(rawMeta) {
    this.zfType = rawMeta.zf_type !== undefined ? rawMeta.zf_type : this.zfType;
    this.entityName = rawMeta.entity_name !== undefined ? rawMeta.entity_name : this.entityName;

    this.dsUid = rawMeta.ds_uid !== undefined ? rawMeta.ds_uid : this.dsUid;
    this.dsUid = this.dsUid == null ? this.rootEntity.meta.dsUid : this.dsUid;
    this.dsUid = this.dsUid == null ? -1 : this.dsUid;

    this.metaAttrName = rawMeta.meta_field != null ? rawMeta.meta_field : this.metaAttrName;
  }

  async _updateFieldsFromRaw(rawMeta) {
    if (rawMeta.fields != null) {
      await Promise.all(Object.keys(rawMeta.fields).map(async (attr) => {
        const rawField = rawMeta.fields[attr];
        rawField.__meta__ = rawField.__meta__ == null ? {} : rawField.__meta__;
        rawField.__meta__.zf_type = rawField.__meta__.zf_type == null ? (rawField.type == null ? 'field' : 'field.' + rawField.type) : rawField.__meta__.zf_type;

        rawField.attr_name = attr;
        const newField = await window.ZForms.parseRaw(rawField, null, this.rootEntity);
        this.fields[attr] = newField;
      }));
    }

    Object.values(this.fields).forEach((field) => {
      field.parent = this.fields[field.parentAttrName];
      if (field.parent != null) field.parent.childrenFields.push(field);
    });

    this.entityViewField = rawMeta.entity_view_field != null ? this.fields[rawMeta.entity_view_field] : this.entityViewField;
    this.entityUidField = rawMeta.entity_uid_field != null ? this.fields[rawMeta.entity_uid_field] : this.entityUidField;
  }

  async _updateActionsFromRaw(rawMeta) {
    if (rawMeta.actions != null) {
      this.actions = await Promise.all(rawMeta.actions.map(async (rawAction) => {
        rawAction.__meta__ = rawAction.__meta__ == null ? {} : rawAction.__meta__;
        rawAction.__meta__.zf_type = rawAction.__meta__.zf_type == null ? (rawAction.type == null ? 'action' : 'action.' + rawAction.type) : rawAction.__meta__.zf_type;
        return await window.ZForms.parseRaw(rawAction, null, this.rootEntity);
      }));
    } else this.actions = rawMeta.actions === undefined ? this.actions : [];
  }

  async updateFromRaw(rawMeta) {
    await this._updateParamsFromRaw(rawMeta);
    await this._updateFieldsFromRaw(rawMeta);
    await this._updateActionsFromRaw(rawMeta);
    return this;
  }

  updateFromOtherMeta(otherMeta) {
    Object.keys(this).forEach((attr) => this[attr] = otherMeta[attr] == null ? this[attr] : otherMeta[attr]);
  }
}

export default window.ZForms.registerClass('entity', class ZEntity {
  constructor(baseMeta, rootEntity) {
    this.baseMeta = baseMeta;
    this.rootEntity = rootEntity == null ? this : rootEntity;
    this.meta = null;
    this.rawView = null;
    this.rawUid = null;
    // this.userSelect = false;
    // this.userFavorite = false;
    this.values = {};
    this.errors = {};
    this.changeListeners = [];
  }

  packResponseAttr(attrName) {
    if (
      this.meta == null ||
      this.meta.fields == null ||
      this.meta.fields[attrName] == null ||
      this.meta.fields[attrName].packResponseValue == null
    ) return undefined;
    return this.meta.fields[attrName].packResponseValue(this.values[attrName]);
  }

  packResponse() {
    return Object.fromEntries(Object.keys(this.values).map((attrName) => {
      return [attrName, this.packResponseAttr(attrName)];
    }).filter((entries) => entries[1] !== undefined));
  }

  getEmptyMeta() {
    return new EntityMeta(this.rootEntity);
  }

  getUid() {
    let ans = null;
    if (this.meta.entityUidField != null) {
      ans = this.values[this.meta.entityUidField.attrName];
    }
    if (ans == null) ans = this.rawUid;

    return ans;
  }

  getView() {
    let ans = null;
    if (this.meta.entityViewField != null) {
      ans = this.values[this.meta.entityViewField.attrName];
      return ans;
    }
    if (ans == null) ans = this.rawView;
    if (ans != null) return ans;

    ans = (
      Object.values(this.meta.fields).filter(
          (field) => !field.isHidden && field.rawZFType == 'field.text',
      ).map((field) => this.values[field.attrName])
    ).filter((elem) => elem != null)[0];

    if (ans != null) return ans;
    ans = this.getUid();

    if (ans != null) {
      return [
        this.meta.entityName == null ? 'Entity' : this.meta.entityName,
        this.meta.dsUid == null ? null : `from ds_${this.meta.dsUid}`,
        `"${ans}"`,
      ].filter((elem) => elem != null).join(' ');
    }

    ans = [
      this.meta.entityName == null ? null : this.meta.entityName,
      this.inContainerNumber == null ? null : `container number ${this.inContainerNumber}`,
      this.meta.dsUid == null ? null : `entity from ds_${this.meta.dsUid}`,
    ].filter((elem) => elem != null).join(' ');
    ans = ans == '' ? 'Unknoun entity' : ans;

    return ans;
  }

  toString() {
    return this.getView();
  }

  async _updateParamsFromRaw(rawData) {
    this.rawView = rawData.view === undefined ? this.rawView : rawData.view;
    this.rawUid = rawData.uid === undefined ? this.rawUid : rawData.uid;
  }

  async _updateMetaFromRaw(rawData) {
    this.meta = this.meta == null ? this.getEmptyMeta() : this.meta;
    if (this.baseMeta != null) await this.meta.updateFromOtherMeta(this.baseMeta);
    if (rawData[this.meta.metaAttrName] != null) {
      await this.meta.updateFromRaw(rawData[this.meta.metaAttrName]);
    }
  }

  async _updateValuesAndErrorsFromRaw(rawData) {
    await Promise.all(Object.keys(this.meta.fields).map(async (field) => {
      let objVal = rawData[field];
      const fieldDefault = this.meta.fields[field].getDefault();
      if (objVal === undefined && fieldDefault === undefined) return;

      objVal = this.meta.fields[field].errorable ? (objVal == null ? objVal : objVal.value) : objVal;
      const errorVal = this.meta.fields[field].errorable ? (objVal == null ? undefined : objVal.error) : undefined;

      this.values[field] = (
        objVal === undefined ?
        fieldDefault :
        await this.meta.fields[field].parseRawValue(objVal)
      );

      this.errors[field] = errorVal;
    }));
  }

  async updateFromRaw(rawData) {
    await this._updateParamsFromRaw(rawData);
    await this._updateMetaFromRaw(rawData);
    await this._updateValuesAndErrorsFromRaw(rawData);
    return this;
  }

  setValue(attrName, newVal) {
    const curError = this.meta.fields[attrName].validateValue(newVal);
    this.values[attrName] = newVal;
    this.setError(attrName, curError);
  }

  setError(attrName, newError) {
    this.errors[attrName] = newError;
    this.callChangeListeners();
  }

  addChangeListener(listener) {
    this.changeListeners.push(listener);
  }

  callChangeListeners() {
    this.changeListeners.forEach((listener) => listener(this));
  }

  removeChangeListener(listener) {
    const index = this.changeListeners.indexOf(listener);
    if (index > -1) this.changeListeners.splice(index, 1);
  }

  async makeRequest(action, useEntity, forceUpdate, respRoot) {
    if (useEntity == null) useEntity = this.rootEntity;

    // return await requester({
    //   entityName: useEntity.meta.entityName,
    //   entityUid: useEntity.getUid(),
    //   // subscriptionUid,
    //   dsUid: useEntity.meta.dsUid,
    //   forceUpdate: forceUpdate,
    //   // pageUid: pageUid,
    //   actionData: {
    //     root: {
    //       entity_name: this.rootEntity.meta.entityName,
    //       entity_uid: this.rootEntity.getUid(),
    //       ds_uid: this.rootEntity.meta.dsUid,
    //     },
    //     action: action.packResponse(),
    //     entity: useEntity.packResponse(),
    //   },
    //   rootEntity: respRoot,
    // });
  }

  async makeAction(action, triggerEntity) {
    if (action == null) return;

    triggerEntity = triggerEntity == null ? this : triggerEntity;

    if (this.rootEntity != this) {
      return await this.rootEntity.makeAction(action, triggerEntity);
    }

    return await this.makeRequest(action, triggerEntity, false, this.rootEntity);
  }

  async updateRootFromAction(action, triggerEntity) {
    if (action == null) return;

    triggerEntity = triggerEntity == null ? this : triggerEntity;

    if (this.rootEntity != this) {
      return await this.rootEntity.updateRootFromAction(action, triggerEntity);
    }

    const newEntityResp = await this.makeAction(action, triggerEntity);

    if (newEntityResp == null) return;

    console.log('newEntityResp', newEntityResp);
  }

  async callNewRootEntityByTrigger(triggerAction, triggerEntity) {
    triggerEntity = triggerEntity == null ? this : triggerEntity;

    if (this.rootEntity != this) {
      return await this.rootEntity.callNewRootEntityByTrigger(triggerAction, triggerEntity);
    }

    const action = triggerEntity.meta.actions.map((action) => action.hasTrigger(triggerAction)).filter((action) => action != null)[0];

    if (action == null) return;
    const newEntityResp = await this.makeRequest(action, triggerEntity, false, null);

    if (newEntityResp.status != 200) {
      window.openAcceptWindow(newEntityResp.errorText + '\n' + newEntityResp.errorDescription, 'Ошибка открытия!');
      return;
    }

    if (newEntityResp.result.getPainter == null) {
      console.log('subEntity.result', newEntityResp.result);
      window.openAcceptWindow('Сущность ' + newEntityResp.result.getView() + ' не может быть отображена!', 'Ошибка открытия!');
      return;
    }

    console.log('subEntity.result', newEntityResp.result);
    window.openWindow({
      caption: newEntityResp.result.getView(),
      component: newEntityResp.result.getPainter(),
      innerProps: {
        'data_struct': newEntityResp.result,
      },
    });
  }

  // async callAction(action) {
  //   if (action == null) return;
  //   return await action.exec(this);
  // }

  // async triggerAction(trigger) {
  //   const triggerAction = this.meta.actions.map((action) => action.hasTrigger(trigger)).filter((action) => action != null)[0];
  //   return await this.callAction(triggerAction);
  // }

  // async openSubEntityByTrigger(trigger) {
  //   const subEntity = await this.triggerAction(trigger);
  //   if (subEntity == null) return;

  //   if (subEntity.status != 200) {
  //     window.openAcceptWindow(subEntity.errorText + '\n' + subEntity.errorDescription, 'Ошибка открытия!');
  //     return;
  //   }

  //   if (subEntity.result.getPainter == null) {
  //     console.log('subEntity.result', subEntity.result);
  //     window.openAcceptWindow('Сущность ' + subEntity.result.getView() + ' не может быть отображена!', 'Ошибка открытия!');
  //     return;
  //   }
  //   console.log('subEntity.result', subEntity.result);
  //   window.openWindow({
  //     caption: subEntity.result.getView(),
  //     component: subEntity.result.getPainter(),
  //     innerProps: {
  //       'data_struct': subEntity.result,
  //     },
  //   });
  // }

  canAction(actionTriggerType) {
    let ans = false;
    this.meta.actions.forEach((action) => ans = ans || action.hasTrigger(actionTriggerType) != null);

    return ans;
  }
});
